import React from 'react';

/**
 * Metallic pill button: chrome rim and glossy black face.
 * Styling lives in src/styles/metal-button.css.
 */
const MetalButton = ({ as: Tag = 'button', block = false, className = '', children, ...rest }) => {
    const classes = ['metal-btn', block ? 'metal-btn-block' : '', className]
        .filter(Boolean)
        .join(' ');

    return (
        <Tag className={classes} {...rest}>
            <span className="metal-rim" aria-hidden="true" />
            <span className="metal-label">{children}</span>
        </Tag>
    );
};

export default MetalButton;
